import { db } from "../../../../mp-database"

/**
 * Fetches the timeRemaining data from db
 * @param {string} userAssessmentId id of the userAssessment
 */
export default function getTimeRemaining(userAssessmentId) {
  return db
    .collection("timeRemaining")
    .doc(userAssessmentId)
    .get()
    .then(doc => {
      const timeRemaining = doc.data()
      return timeRemaining ? timeRemaining.timeRemaining : {}
    })
}
